export const baseStudentPlan = {
  'freshman' : [
    {
      label        : 'English',
      gradCredits  : ['-English-English-1', '-English'],
      gradRequired : true,
      movable      : false,
      courses      : [],
    },
    {
      label        : 'Freshman Seminar / Health',
      gradCredits  : ['-History-&-Social-Studies-Elective'],
      gradRequired : true,
      movable      : false,
      courses      : [],
    },
    {
      label        : 'Life or Physical Science',
      gradCredits  : ['-Science-Life-Science', '-Science-Physical-Science'],
      gradRequired : true,
      movable      : true,
      courses      : [],
    },
    {
      label        : 'Mathematics',
      gradCredits  : ['-Mathematics'],
      gradRequired : true,
      movable      : true,
      courses      : [],
    },
    {
      label        : 'Art / World Language',
      gradCredits  : ['-Art-&-World-Language'],
      gradRequired : true,
      movable      : true,
      courses      : [],
    },
    {
      label        : 'PE / Athletics',
      gradCredits  : ['-Physical-Education'],
      gradRequired : true,
      movable      : true,
      courses      : []
    },
    {
      label        : 'Elective / CTE',
      gradCredits  : ['-CTE', '-Electives'],
      gradRequired : true,
      movable      : true,
      courses      : [],
    },
    {
      label        : '',
      gradCredits  : '',
      gradRequired : false,
      movable      : true,
      courses      : [],
    },
  ],

  'sophomore' : [
    {
      label        : 'English',
      gradCredits  : ['-English-English-2', '-English'],
      gradRequired : true,
      movable      : false,
      courses      : [],
    },
    {
      label        : 'World History',
      gradCredits  : ['-History-&-Social-Studies-World-History'],
      gradRequired : true,
      movable      : false,
      courses      : [],
    },
    {
      label        : 'Life or Physical Science',
      gradCredits  : ['-Science-Life-Science', '-Science-Physical-Science'],
      gradRequired : true,
      movable      : true,
      courses      : [],
    },
    {
      label        : 'Mathematics',
      gradCredits  : ['-Mathematics'],
      gradRequired : true,
      movable      : true,
      courses      : [],
    },
    {
      label        : 'Art / World Language',
      gradCredits  : ['-Art-&-World-Language'],
      gradRequired : false,
      movable      : true,
      courses      : [],
    },
    {
      label        : 'PE / Athletics',
      gradCredits  : ['-Physical-Education'],
      gradRequired : true,
      movable      : true,
      courses      : [],
    },
    {
      label        : 'Elective / CTE',
      gradCredits  : ['-CTE', '-Electives'],
      gradRequired : true,
      movable      : true,
      courses      : [],
    },
    {
      label        : '',
      gradCredits  : '',
      gradRequired : false,
      movable      : true,
      courses      : [],
    },
  ],

  'junior' : [
    {
      label        : 'English',
      gradCredits  : ['-English-English-3', '-English'],
      gradRequired : true,
      movable      : false,
      courses      : [],
    },
    {
      label        : 'US History',
      gradCredits  : ['-History-&-Social-Studies-US-History'],
      gradRequired : true,
      movable      : false,
      courses      : [],
    },
    {
      label        : 'Science',
      gradCredits  : ['-Science'],
      gradRequired : true,
      movable      : true,
      courses      : [],
    },
    {
      label        : 'Mathematics',
      gradCredits  : ['-Mathematics'],
      gradRequired : false,
      movable      : true,
      courses      : [],
    },
    {
      label        : 'Elective / CTE',
      gradCredits  : ['-CTE', '-Electives'],
      gradRequired : false,
      movable      : true,
      courses      : [],
    },
    {
      label        : '',
      gradCredits  : '',
      gradRequired : false,
      movable      : true,
      courses      : [],
    },
    {
      label        : '',
      gradCredits  : '',
      gradRequired : false,
      movable      : true,
      courses      : [],
    },
    {
      label        : '',
      gradCredits  : '',
      gradRequired : false,
      movable      : true,
      courses      : [],
    },
  ],

  'senior' : [
    {
      label        : 'English',
      gradCredits  : ['-English-English-4', '-English'],
      gradRequired : true,
      movable      : false,
      courses      : [],
    },
    {
      label        : 'Government / Econ',
      gradCredits  : ['-History-&-Social-Studies-Government', '-History-&-Social-Studies-Economics'],
      gradRequired : true,
      movable      : false,
      courses      : [],
    },
    {
      label        : 'Elective / CTE',
      gradCredits  : ['-CTE', '-Electives'],
      gradRequired : false,
      movable      : true,
      courses      : [],
    },
    {
      label        : 'Elective / CTE',
      gradCredits  : ['-CTE', '-Electives'],
      gradRequired : false,
      movable      : true,
      courses      : [],
    },
    {
      label        : 'Elective / CTE',
      gradCredits  : ['-CTE', '-Electives'],
      gradRequired : false,
      movable      : true,
      courses      : [],
    },
    {
      label        : '',
      gradCredits  : '',
      gradRequired : false,
      movable      : true,
      courses      : [],
    },
    {
      label        : '',
      gradCredits  : '',
      gradRequired : false,
      movable      : true,
      courses      : [],
    },
    {
      label        : '',
      gradCredits  : '',
      gradRequired : false,
      movable      : true,
      courses      : [],
    },
  ]
};

export default baseStudentPlan;
